import { IActionRelationshipsRequest, RelationshipsState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'
import { RelationshipsData } from '../../services/relationships.service'
import { mergeRelationshipsData } from './utils'

const initialState: RelationshipsState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        data: null
    }
}

export const relationshipsSlice = createSlice({
    name: '@relationships',
    initialState,
    reducers: {
        relationshipsRequest: (state: Draft<RelationshipsState>, _action: PayloadAction<IActionRelationshipsRequest>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        relationshipsSuccess: (
            state: Draft<RelationshipsState>,
            action: PayloadAction<{ data: RelationshipsData; merge?: boolean }>
        ) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.merge && state.request.data
                ? mergeRelationshipsData(state.request.data, action.payload.data)
                : action.payload.data
        },
        relationshipsFailure: (state: Draft<RelationshipsState>) => {
            state.request.status = AsyncStateStatus.FAILURE
        },
        relationshipsReset: (state: Draft<RelationshipsState>) => {
            state.request.status = AsyncStateStatus.INITIAL
            state.request.data = null
        },
    }
})

export const RelationshipsActions = relationshipsSlice.actions

export default relationshipsSlice.reducer
